import { Paper, Typography } from '@mui/material';

export default function MetricCard({ label, value, color = 'text.primary' }) {
  return (
    <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ textTransform: 'uppercase', letterSpacing: 0.4 }}
      >
        {label}
      </Typography>
      <Typography variant="h5" fontWeight={800} sx={{ color }}>
        {value ?? 0}
      </Typography>
    </Paper>
  );
}
